/**
 * Service-worker registration.
 *
 * Runs only in production builds — running it in dev would compete with
 * webpack-dev-server's hot-reload (the SW would serve stale chunks while
 * the dev server pushes new ones).
 *
 * On every reload we also check for an update; if a new SW is waiting,
 * we tell it to skip waiting so the user gets the latest bundle without
 * having to manually kill the app.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Only register on https (or localhost) — required by browsers.
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (window.location.protocol !== 'https:' && !isLocalhost) return;
  // Skip in dev so HMR keeps working.
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // When a new SW takes control, soft-refresh runtime data so the user
        // doesn't sit on a stale shell forever.
        reg.addEventListener('updatefound', () => {
          const next = reg.installing;
          if (!next) return;
          next.addEventListener('statechange', () => {
            if (next.state === 'installed' && navigator.serviceWorker.controller) {
              // A new version is ready in the background — activate now.
              next.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => {
        // Don't spam users — SW registration failures are non-fatal.
        // eslint-disable-next-line no-console
        console.warn('[sw] registration failed:', err);
      });
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
